export function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");

  var regexS = "[\\?&]" + name + "=([^&#]*)",
    regex = new RegExp(regexS),
    results = regex.exec(window.location.search);

  if (results == null) {
    return "";
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}

export function authorizationRequiredPaths() {
  return {
    "redir/checkout/cart": "Please enter your password to continue",
    "/checkout/cart": "Sign in to proceed with checkout",
    "redir/my_rtr": "Please enter your password to continue",
    "/my_rtr": "Sign in to access your account",
  };
}
